export interface LabelProps {
  htmlFor?: string;
  children: string | number;
}
const Label = ({ htmlFor, children }: LabelProps) => {
  return (
    <label className={'leading-7 block text-sm font-medium text-neutralColor-medium'} htmlFor={htmlFor}>
      {children}
    </label>
  );
};

export default Label;
